/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.tiposdivisiones': 'Tipos Divisiones',
  'tiposDivisiones.agregarTiposDivisiones': 'Crear Tipos Divisiones',
  'tiposDivisiones.modificarTiposDivisiones': 'Editar Tipos Divisiones',
  'tiposDivisiones.tipoDivisionId': 'Tipo División Id',
  'tiposDivisiones.empresaId': 'Empresa Id',
  'tiposDivisiones.tipoDivisionDescripcion': 'Tipo División Descripción',
  'tiposDivisiones.VerTiposDivisiones': 'Ver Tipos Divisiones',
  'tiposDivisiones.RegistroDuplicado': 'Registro Duplicado',
};
